<template>
    
    <div class="solution-services" >

        <div class="service-item">
            <img src="./../../assets/https.png" alt=" https "/>
            <div class="service-title regular">HTTPS<br />Ready</div>
        </div>

        <div class="service-item">
            <img src="./../../assets/analytics.png" alt=" Google analytics "/>
            <div class="service-title regular">Google<br />Analytics</div>
        </div>

        <div class="service-item">
            <img src="./../../assets/seo.png" alt=" SEO "/>
            <div class="service-title regular">SEO<br />Ready</div>
        </div>

        <div class="service-item">
            <img src="./../../assets/rgpd.png" alt=" RGPD "/>
            <div class="service-title regular">RGPD<br />Ready</div>
        </div>

        <div class="service-item">
            <img src="./../../assets/opti.png" alt=" optimisation "/>
            <div class="service-title regular">Site<br />optimisé</div>
        </div>
    
    </div>
</template>

<script>
export default {
    name : 'ServicesItem'
}
</script>

<style scoped>
    .service-item {
        width:70px;
        display: flex;
        justify-items: center;    
        margin-bottom:10px;
        flex-direction:column;
    }

    .service-item img {
        width:70px;   
        margin: 0 auto;
    }

    .service-title {
        color:#1a1a23;
        font-size:15px;
        text-align: center;
    }

    @media screen and (max-width: 1000px ) {
        .solution-services {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
        }

        .service-item {
            margin:10px;
        }
    }

    @media screen and (max-width: 767px ) {
        .solution-services {
            justify-content: center;
        }
    }
</style>